<template>
  <nav class="toHide">

    <template>
      <div class="text-center ma-2 toHide">
        <!-- <v-btn dark @click="snackbar = true">Open Snackbar</v-btn> -->
        <v-snackbar
        multi-line
        center
        v-model="snack"
        >
        {{ $store.state.snackText }}
        <v-btn
        color="pink"
        text
        @click="$store.commit('setSnack', '')"
        >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>


<template>
  <div>
    <v-app-bar app fixed text dark class="black">
      <v-app-bar-nav-icon class="grey--text" @click="drawerToggle()">
      </v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase grey--text">
        <router-link to="/">
          <span>PROFESSIONAL </span>
          <span class="font-weight-light">OPTIONS</span>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- dropdown menu -->
      <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="black grey--text">
              <v-icon left>expand_more</v-icon>
              <span>Menu</span>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="link in links" :key="link.text" router :to="link.route">
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn v-if="!userIsAuthenticated" text color="grey" @click.stop="dialog = true">
          <span>Sign In</span>
          <v-icon right>perm_identity</v-icon>
        </v-btn>
        <v-btn v-if="userIsAuthenticated" text color="grey" @click="logOut">
          <span>Sign Out</span>
          <v-icon right>exit_to_app</v-icon>
        </v-btn>
      </v-app-bar>
    </div>
  </template>


<v-navigation-drawer app 
v-model="drawer" class="black">
<v-layout column align-center>
  <v-flex class="mt-0">
   <p class="white--text subheading mt-1">WELCOME!</p>
   <v-avatar size="85">
    <img class="text-lg-center" src="/avatar.png">
    <!-- <img class="text-lg-center" src="https://loremflickr.com/320/240/vacation"> -->
  </v-avatar>
  <p class="white--text subheading mt-2">{{ techName | uppercase }}</p>
</v-flex>
<v-flex class="mt-4 mb-3">
  <Settings v-if="userIsAuthenticated" @projectAdded="snackbar = true" />
  <v-btn v-if="!userIsAuthenticated" text color="grey" @click.stop="dialog = true">
    <span>Sign In</span>
    <v-icon right>perm_identity</v-icon>
  </v-btn>
</v-flex>
</v-layout>
<v-list>
  <v-list-item v-for="link in links" :key="link.text" router :to="link.route">
    <v-list-item-action>
      <v-icon class="white--text">{{ link.icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</v-list>

<div class="mt-12" align="center" justify="center">
  <p class="subtitle white--text mb-3">Love The App?</p>
  <v-btn 
  class="pb-10 px-8"
  color="success" 
  rounded small 
  @click="donate">
    <v-img 
    class="mr-3 ml-0 pl-0"
    height="40"
    width="40"
    src="/paypal.png"></v-img>
    Send A Tip
  </v-btn>
</div>
</v-navigation-drawer>

  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="490">
    <v-card>
      <v-card-title class="headline">Login or Signup</v-card-title>
        <template>
          <div>
            <v-tabs dark centered grow background-color="black accent-4" class="elevation-2">
            <v-tab> Sign In </v-tab>
            <v-tab> Sign Up </v-tab>
            <v-tab-item> <SignIn /> </v-tab-item>
            <v-tab-item> <SignUp /> </v-tab-item>
          </v-tabs>
        </div>
      </template>
    </v-card>
  </v-dialog>
</v-layout>

</nav>
</template>

<script>
import { bus } from '../main'
import Settings from './Settings'
import SignIn from './SignIn'
import SignUp from './SignUp'

export default {
  components: { Settings, SignIn, SignUp },
  data() {
    return {

      // drawer: false,
      email: '',
      password: '',
      links: [
      { icon: 'dashboard', text: 'Options Creator', route: '/options' },
      { icon: 'collections_bookmark', text: 'PriceBook', route: '/add' },
      { icon: 'history', text: 'History', route: '/history' },
      { icon: 'group', text: 'Users', route: '/users' },
      // { icon: 'build', text: 'Dev', route: '/dev' },
      ],
      snackbar: false
    }
  },
  computed: {
    dialog:{
      set(val){
        this.$store.commit('signInDialog', val)
      },
      get(){
        return this.$store.state.signInDialog
      }
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    user () {
      return this.$store.getters.user
    },
    techName () {
      return this.$store.getters.techName
    },
    drawer: {
      set(bool) {
        this.$store.commit('drawerMenu', bool)
      },
      get() {
        return this.$store.getters.drawerMenu
      }
    },
    snack: {
      set(msg) {
        this.$store.commit('setSnack', msg)
      },
      get() {
        return this.$store.state.snack
      }
    },
  },
  watch: {

  },
  methods: {
    donate(){
      window.open('https://paypal.me/kodiei?locale.x=en_US', '_blank')
    },
    logOut() {
      this.$store.dispatch('logOut')
    },
    drawerToggle() {
      this.$store.getters.drawerMenu == false 
      ? this.$store.commit('drawerMenu', true) 
      : this.$store.commit('drawerMenu', false)
    }
  },
  created() {

  },

}

</script>

<style scoped>
nav {
  padding-top: 56px;
}
@media print {
  .toHide {
    display: none;
    z-index: -20;
  }
  nav {
    padding-top: 0px;
  }

}
</style>


